import type { CommercePlatform } from "./platform";

const FOOTER_SCRIPT_URL =
  "https://www.esangdan.com/widgets/footer.js?v=20260731-25";

export type SharedFooterDataset = {
  theme: string;
  lang: string;
  division: string;
  app: string;
  siteLogo: string;
  siteLogoAlt: string;
  siteUrl: string;
  instagramUrl?: string;
  youtubeUrl?: string;
  tiktokUrl?: string;
  appStoreUrl?: string;
  playStoreUrl?: string;
};

export function sharedFooterDataset(
  platform: CommercePlatform,
): SharedFooterDataset {
  const common: SharedFooterDataset = {
    theme: "dark",
    lang: "ko",
    division: "apps",
    app: "Snapcast Studio",
    siteLogo: "/brand/snapcast-logo-white.png",
    siteLogoAlt: "Snapcast Studio",
    siteUrl: "https://snapcast.esangdan.com/studio/",
  };

  // Naver's solution review forbids using the developer landing page to
  // promote installation of separate mobile apps.  Omitting these attributes
  // prevents the shared footer widget from rendering store badges at all.
  if (platform === "naver") {
    return {
      ...common,
      app: "Snapcast for Naver",
      siteLogoAlt: "Snapcast for Naver",
      siteUrl: "https://naver.snapcast.esangdan.com/",
    };
  }

  return {
    ...common,
    instagramUrl: "https://www.instagram.com/snapcastapps/",
    youtubeUrl: "https://www.youtube.com/channel/UCUf6frUZnrH7mkpHMCQK2XQ",
    tiktokUrl: "https://www.tiktok.com/@snapcastapps",
    appStoreUrl: "https://apps.apple.com/kr/app/id6793435903",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.leesangdan.snapcast.studio.android",
  };
}

export function loadSharedFooter(platform: CommercePlatform) {
  if (typeof document === "undefined") return;
  if (document.querySelector('script[data-snapcast-shared-footer="true"]')) {
    return;
  }

  const script = document.createElement("script");
  script.src = FOOTER_SCRIPT_URL;
  script.dataset.snapcastSharedFooter = "true";

  const dataset = sharedFooterDataset(platform);
  Object.entries(dataset).forEach(([key, value]) => {
    if (value) script.dataset[key] = value;
  });

  document.body.appendChild(script);
}
